// extracted by mini-css-extract-plugin
module.exports = {"companySelect-item":"CompanySelectItem_companySelect-item__wrD7y","active":"CompanySelectItem_active__2oXqz"};